export enum TicketType {
  EMAIL = "email",
  CHAT = "chat",
  PHONE = "phone",
  LOGGED_OUT = "logged_out",
}

export const FOURTEEN_DAYS = 14;

export const BRAND_ORDERS_PAGE_SIZE = 8;

export enum SelfServeSource {
  HOME_PAGE_HEADER = "HOME_PAGE_HEADER",
  CONTACT_US_SIDE_BANNER = "CONTACT_US_SIDE_BANNER",
  CONTACT_US_FOOTER_BANNER = "CONTACT_US_FOOTER_BANNER",
}

/**
 * Based on the width of email us and chat cards together one after another
 * in the answer view
 */
export const CONTACT_CARDS_COMBINED_WIDTH = "556px";

export enum Strategy {
  DECAGON = "decagon",
  SELF_SERVE = "self_serve",
}
